import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BookingFlowProvider } from "./session/BookingFlowProvider";
import { resolveBridge } from "./bridge";
import { launchLanguage, launchMode, launchPublicKey } from "./bootstrap";
import { proveParentOrigin, publishEmbedEvent, startHeightSync } from "./embed/embedChannel";
import "./index.css";

const mode = launchMode();
const container = document.getElementById("root");
if (!container) throw new Error("#root fehlt");
const root = container;

if (mode === "embed") startHeightSync();

async function start() {
  const launchOrigin = mode === "embed" ? await proveParentOrigin() : window.location.origin;
  createRoot(root).render(
    <StrictMode>
      <BookingFlowProvider
        bridge={resolveBridge()}
        publicKey={launchPublicKey()}
        launchOrigin={launchOrigin}
        language={launchLanguage()}
        onReady={() => publishEmbedEvent({ type: "exodus.booking.ready" })}
      >
        <App mode={mode} />
      </BookingFlowProvider>
    </StrictMode>,
  );
}

void start().catch(() => {
  createRoot(root).render(
    <div className="booking-boot" role="alert">
      <p>Die Buchung darf auf dieser Seite nicht gestartet werden.</p>
    </div>,
  );
});
